import React, { useState, useEffect } from "react";
import { PageApiQueueProvider, usePageApiQueue } from "../../Components/Hooks/PageApiQueue";
import {
  Col,
  Container,
  Row,
  Button,
  CardBody,
  Card
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import FlashDatePicker from "../../Components/Common/FlashDatePicker";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import OverallWidget from "./OverallWidget";
import TeamMemberPerformance from "./TeamMemberPerformance";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { DISCOUNT, NEWDISCOUNT } from "../../helpers/data_helper";
import DailyDiscountDistribution from "./DailyDiscountDistribution";
import DayOfWeekDiscountPerformance from "./DayofWeekDiscountPerformance";
import DiscountTrends from "../Discount/DiscountTrends";
import DiscountPerformance from "../Discount/DiscountPerformance";
import DiscountDetails from "../Discount/DiscountDetails";
import LazySection from "./LazySection";
import Loader from "../../Components/Common/Loader";


const DiscountNewContent = () => {
  const { enqueue } = usePageApiQueue();
  document.title = "KPI Dashboard | " + process.env.REACT_APP_NAME;
  const [leftCustomDate, setLeftCustomDate] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const handleRefresh = () => {
    setRefresh(!refresh);
  }

  const [mealPeriod, setMealPeriod] = useState("0");
  const [filtermealperiod, setFiltermealperiod] = useState([]);
  const [filterDateList, setFilterDateList] = useState([]);
  const [currency, setCurrency] = useState('$');
  const [selectedMealList, setSelectedMealList] = useState(["all"]);
  const [filterdiscountCodes, setFilterdiscountCodes] = useState([]);
  const [discountCodes, setdiscountCodes] = useState([]);
  const [selectedDiscountCodes, setSelectedDiscountCodes] = useState([]);
  const [serveList, setserveList] = useState([]);
  const [selectedServeList, setSelectedServeList] = useState([]);
  const [filterserveList, setFilterserveList] = useState([]);
  const durations = ["30", "60", "90"];
  const [activeTab, setActiveTab] = useState(durations[0]);
  // Gate Performance until these section APIs have *started* (not finished)
  const [apiStarted, setApiStarted] = useState({
    daily: false,
    heatmap: false,
    dayOfWeek: false,
    details: false,
  });
  const [discountListReady, setDiscountListReady] = useState(false);

  const markApiStart = (key) => {
    setApiStarted((prev) => (prev[key] ? prev : { ...prev, [key]: true }));
  };

  // Performance only after heatmap (and other sections) have actually started their APIs
  const performanceCanStart =
    apiStarted.daily &&
    apiStarted.heatmap &&
    apiStarted.dayOfWeek &&
    apiStarted.details;


  const changeDiscountCodes = (value) => {
    setSelectedDiscountCodes(value);
    let selVal = [];
    value.map((item) => {
      selVal.push(item.value);
    });
    setdiscountCodes(selVal);
  };

  const changeServerList = (value) => {
    setSelectedServeList(value);
    let selVal = [];
    value.map((item) => {
      selVal.push(item.value);
    });
    setserveList(selVal);
  };

  const changeMealPeriod = (value) => {
    setSelectedMealList(value);
    if (value === "all") {
      setMealPeriod(0);
    } else {
      setMealPeriod(value);
    }
  };
  const {
    filterData,
    filterAjax,
    currentOutlet
  } = useSelector((state) => ({
    filterData: state.Dashboard.filterData,
    filterAjax: state.Dashboard.filterAjax,
    currentOutlet: state.UserOutletGroup.currentOutlet
  }));

  const [leftFilter, setLeftFilter] = useState(
    filterData.flash_date?.find((date) => date.default) || false
  );

  useEffect(() => {
    if (filterData.serverList) {
      setFilterserveList(filterData.serverList);
    }
    if (filterData.mealperiod) {
      setFiltermealperiod(filterData.mealperiod);
    }
    if (filterData.flash_date) {
      setLeftFilter(
        (prev) => prev || filterData.flash_date.find((date) => date.default)
      );
      setFilterDateList(filterData.flash_date);
    }
  }, [filterAjax, filterData]);
  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency);
    }
  }, [currentOutlet]);

  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency)
    }
  }, [currentOutlet]);

  // Reset API sequencing when filters change
  useEffect(() => {
    setApiStarted({
      daily: false,
      heatmap: false,
      dayOfWeek: false,
      details: false,
    });
  }, [leftFilter, mealPeriod, serveList, discountCodes, refresh]);

  useEffect(() => {
    setDiscountListReady(false);
    return enqueue(
      "DiscountList",
      1,
      async (signal) => {
        try {
          const response = await postDataAPI({
            serviceName: DISCOUNT.serviceName,
            op: DISCOUNT.op_discount_lists,
            leftFilter: leftFilter,
            mealPeriod: mealPeriod,
            page: 0,
            server_id: [],
            discount_id: [],
          }, signal);
          if (signal.aborted) return;
          if (response.status === "ok") {
            const discountListArr = [];
            response.data.discount_list.map((item) => {
              discountListArr.push({
                value: item.value,
                label: item.lable
              });
            })
            setFilterdiscountCodes(discountListArr);
            setDiscountListReady(true);
          } else {
            console.log(response.data);
            setFilterdiscountCodes([]);
            setDiscountListReady(true);
          }
        } catch (e) {
          if (!signal.aborted) setDiscountListReady(true);
        }
      }
    );


  }, [mealPeriod, leftFilter, enqueue]);

  let date = new Date();
  date.setDate(date.getDate() - 1);

  const getMealString = (selectedMealList) => {
    const match = filtermealperiod.find(item => item.value === selectedMealList);
    return match ? match.label : "All Meal";
  };
  const mealString = getMealString(selectedMealList);

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Discount & Promotion"
            pageTitle="Dashboard"
            activeDate={leftFilter}
            customDate={leftCustomDate}
            handleRefresh={handleRefresh}
            server_id={serveList}
            discount_id={discountCodes}
            mealPeriod={mealPeriod}
            trend_period={activeTab}
          />
          <Card className="p-0 row card-body">
            <CardBody className="mb-1">
              <form className="">
                <Row>
                  <Col className="mb-2 mb-lg-0" sm={12} lg={3}>
                    <FlashDatePicker
                      filterDateList={filterDateList}
                      activeDate={leftFilter}
                      setActiveDate={setLeftFilter}
                      posEnd={false}
                    />
                  </Col>
                  <Col className="mb-2 mb-lg-0" sm={12} lg={3}>
                    <select
                      className="form-select"
                      value={mealPeriod}
                      id="mealPeriod"
                      onChange={(event) => changeMealPeriod(event.target.value)}
                    >
                      <option value="0">All Meal Periods</option>
                      {!filterAjax &&
                        filtermealperiod.length > 0 &&
                        filtermealperiod.map((item) => {
                          return (
                            <option key={item.sp_id} value={item.sp_id}>
                              {item.title +
                                " (" +
                                item.start_time +
                                " To " +
                                item.end_time +
                                ")"}
                            </option>
                          );
                        })}
                    </select>
                  </Col>
                  <Col className="mb-2 mb-lg-0" sm={12} lg={3}>
                    <div>
                      <Select
                        value={selectedDiscountCodes}
                        isMulti={true}
                        onChange={(value) => {
                          changeDiscountCodes(value);
                        }}
                        options={filterdiscountCodes}
                        placeholder="All Discount Codes"
                      />
                    </div>
                  </Col>
                  <Col sm={12} lg={3}>
                    <Select
                      value={selectedServeList}
                      isMulti={true}
                      onChange={(value) => {
                        changeServerList(value);
                      }}
                      options={filterserveList}
                      placeholder="All servers"
                    />
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
          <Row>
            {!leftFilter ? (
              <Col xl={12}>
                <Loader />
              </Col>
            ) : (
              <>
                {/* Priority 1 — above the fold: load immediately */}
                <OverallWidget
                  mealPeriod={mealPeriod}
                  leftFilter={leftFilter}
                  discountCodes={discountCodes}
                  serveList={serveList}
                  currency={currency}
                />

                <Col xl={12}>
                  <TeamMemberPerformance
                    mealPeriod={mealPeriod}
                    leftFilter={leftFilter}
                    discountCodes={discountCodes}
                    serveList={serveList}
                    currency={currency}
                  />
                </Col>

                {/* Eager staggered mounts — APIs start on mount; Performance waits until others started */}
                <Col xl={12}>
                  <LazySection delayMs={300} minHeight={280} eager>
                    <DailyDiscountDistribution
                      mealPeriod={mealPeriod}
                      leftFilter={leftFilter}
                      discountCodes={discountCodes}
                      serveList={serveList}
                      currency={currency}
                      onApiStart={() => markApiStart("daily")}
                    />
                  </LazySection>
                </Col>

                <Col xl={12} className="p-0">
                  <LazySection delayMs={500} minHeight={360} eager>
                    <DiscountTrends
                      mealPeriod={mealPeriod}
                      leftFilter={leftFilter}
                      discountCodes={discountCodes}
                      allDiscountList={filterdiscountCodes}
                      discountListReady={discountListReady}
                      serveList={serveList}
                      currency={currency}
                      changeDiscountCodes={changeDiscountCodes}
                      onApiStart={() => markApiStart("heatmap")}
                    />
                  </LazySection>
                </Col>

                <Col xl={12} className="p-0">
                  <LazySection delayMs={700} minHeight={320} eager>
                    <DayOfWeekDiscountPerformance
                      mealPeriod={mealPeriod}
                      leftFilter={leftFilter}
                      discountCodes={discountCodes}
                      serveList={serveList}
                      currency={currency}
                      durations={durations}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      onApiStart={() => markApiStart("dayOfWeek")}
                    />
                  </LazySection>
                </Col>

                {/* UI position stays here; API waits until daily/heatmap/dow/details have started */}
                <Col xl={12} className="p-0">
                  <LazySection
                    delayMs={0}
                    minHeight={360}
                    eager
                    enabled={performanceCanStart}
                  >
                    <DiscountPerformance
                      mealPeriod={mealPeriod}
                      leftFilter={leftFilter}
                      discountCodes={discountCodes}
                      serveList={serveList}
                      currency={currency}
                    />
                  </LazySection>
                </Col>

                <Col xl={12} className="p-0">
                  <LazySection delayMs={900} minHeight={360} eager>
                    <DiscountDetails
                      mealPeriod={mealPeriod}
                      leftFilter={leftFilter}
                      discountCodes={discountCodes}
                      serveList={serveList}
                      currency={currency}
                      onApiStart={() => markApiStart("details")}
                    />
                  </LazySection>
                </Col>
              </>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const DiscountNew = () => (
  <PageApiQueueProvider>
    <DiscountNewContent />
  </PageApiQueueProvider>
);

export default DiscountNew;
